<template>
<div>
    <div v-for="(element, elementIndex) in items" :key="`${owner}-item-${elementIndex}`">
        <div v-if="!!element.items">
            <v-list-group v-model="element.active" no-action :group="element.domain">
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title>{{element.title}}</v-list-item-title>
                    </v-list-item-content>
                </template>
                <v-list-item v-for="(child, childIndex) in element.items" :key="`${owner}-item-${elementIndex}-child-${childIndex}`" :to="child.to" exact  style="padding-left: 32px;">
                    <v-list-item-content>
                        <v-list-item-title v-text="child.title"></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-group>
        </div>
        <div v-else>
            <v-list-item-group active-class="primary white--text">
                <v-list-item :to="element.to" exact>
                    <v-list-item-icon v-if="element.option?.new" style="margin-right: 1rem !important; margin-top: .85rem !important;"><v-icon color="accent">mdi-shimmer</v-icon></v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{element.title}}</v-list-item-title>
                        <v-list-item-subtitle v-if="element.option?.new">¡Nueva Herramienta!</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
        </div>
    </div>
</div>

</template>
<script>
export default {
    props: ['items', 'owner'],
    data: function () {
        return {
            list: [],
        };
    },
    methods: {
        setList: function () {
        }
    },
    computed: {
    },
    watch: {

    }
}
</script>